import Swal from 'sweetalert2';

const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 10000,
})

const notifyError = (err) => {
    
    let code = 'inconnue'
    let message = 'Une erreur est survenue'

    if (err.response) {
        code = err.response.status
        message = err.response.data?.message
    }

    Toast.fire({
        type: 'error',
        html: `<h5>Erreur: ${code}</h5><p>${message}</p>`
    })
}

// import { loadUsers as loadUsersService } from "@components/services/resources.js";
export const loadUsers = async ()  => {
    return window
        .axios({
            method: "get",
            url: "/api/referentiel/users",
            params: {
                perpage: 9999,
                include: []
            }
        })
        .then(response => {
            let users = response.data.data;

            if (users.length == 0) return;

            users.slice().map(u => {
                u.label = `${u.name} (${u.email})`;
                return u;
            });

            return users;
        })
        .catch(err => {
            console.log(err, err.response);
            notifyError(err)
        });
}

// import { loadRatingQuestionnaires } from "@components/services/resources.js";
export const loadRatingQuestionnaires = async ()  => {
    return window
        .axios({
            method: "get",
            url: "/api/referentiel/rating-questionnaires",
            params: {
                perpage: 9999,
                include: []
            }
        })
        .catch(err => {
            console.log(err, err.response);
            notifyError(err)
        });
}

// import { reloadAppUser as reloadAppUserService } from "@components/services/resources.js";
export const reloadAppUser = async () => {
    return window
        .axios({
            method: "get",
            url: `/api/referentiel/users/profile`,
            params: {}
        })
        .then(response => {
            window.Laravel.user = response.data;
        })
        .catch(err => {
            console.log(err, err.response);
            notifyError(err)
        });
}

// import { loadOccupationSkills } from "@components/services/resources.js";
export const loadOccupationSkills = async ({ perpage = 9999, include = [], filter = null, page = null, search = null })  => {
    return window
        .axios({
            method: "get",
            url: "/api/referentiel/occupation-skills",
            params: { perpage, include, filter, page, search }
        })
        .catch(err => {
            console.log(err, err.response);
            notifyError(err)
        });
}

// import { loadAdminOccupationSkills } from "@components/services/resources.js";
export const loadAdminOccupationSkills = async ({ perpage = 9999, include = [], filter = null, page = null, search = null })  => {
    return window
        .axios({
            method: "get",
            url: "/api/admin/occupation-skills",
            params: { perpage, include, filter, page, search }
        })
        .catch(err => {
            console.log(err, err.response);
            notifyError(err)
        });
}

// import { loadOccupations } from "@components/services/resources.js";
export const loadOccupations = async ({ perpage = 9999, include = [], filter = null, page = null, search = null })  => {
    return window
        .axios({
            method: "get",
            url: "/api/referentiel/occupations",
            params: { perpage, include, filter, page, search }
        })
        .catch(err => {
            console.log(err, err.response);
            notifyError(err)
        });
}

// import { loadAdminOccupations } from "@components/services/resources.js";
export const loadAdminOccupations = async ({ perpage = 9999, include = [], filter = null, page = null, search = null }) => {
    return window.axios({
        method: 'get',
        url: '/api/admin/occupations',
        params: { perpage, include, filter, page, search }
    })
    .catch((err) => {
        console.log(err, err.response);
        notifyError(err)
    })
}

// import { loadSectors } from "@components/services/resources.js";
export const loadSectors = async ({ perpage = 9999, include = [], filter = null, page = null, search = null }) => {
    return window.axios({
        method: 'get',
        url: '/api/admin/sectors',
        params: { perpage, include, filter, page, search }
    })
    .catch((err) => {
        console.log(err, err.response);
        notifyError(err)
    })
}

// import { loadExperienceTypes } from "@components/services/resources.js";
export const loadExperienceTypes = async ({ perpage = 9999, include = [], filter = null, page = null, search = null }) => {
    return window.axios({
        method: 'get',
        url: '/api/referentiel/experience-types',
        params: { perpage, include, filter, page, search }
    })
    .catch((err) => {
        console.log(err, err.response);
        notifyError(err)
    })
}

// import { loadGrids } from "@components/services/resources.js";
export const loadGrids = async ({ perpage = 9999, include = [], filter = null, page = null, search = null }) => {
    return window.axios({
        method: 'get',
        url: '/api/referentiel/grids',
        params: { perpage, include, filter, page, search }
    })
    .catch((err) => {
        console.log(err, err.response);
        notifyError(err)
    })
}
